import { plugin as engagementPlugin } from '@amplitude/engagement-browser'
import React, { FC, ReactNode, createContext, useLayoutEffect, useMemo, useState } from 'react'
import { events } from '../engagement/events'
import { BrowserClient } from 'src/ampli'

type EngagementContext = { engagement: boolean }

declare global {
  interface Window {
    engagement: any
  }
}

const IS_SERVER = typeof window === 'undefined'

export const AmplitudeEngagementContext = createContext<EngagementContext>({ engagement: false })

export const AmplitudeEngagementProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [engagement, setEngagement] = useState(false)

  if (IS_SERVER) {
    return <>{children}</>
  }

  const onAmplitudeReady = (client: BrowserClient) => {
    console.log('Amplitude Engagement Client ready')

    const surveysPlugin = engagementPlugin()
    client.add(surveysPlugin)

    setEngagement(true)
  }

  useLayoutEffect(() => {
    if (engagement) return

    events.once('ready', onAmplitudeReady, 0)

    return () => {
      events.off('ready', onAmplitudeReady)
    }
  })

  const context = useMemo(() => ({ engagement }), [engagement])

  return (
    <AmplitudeEngagementContext.Provider value={context}>
      {children}
    </AmplitudeEngagementContext.Provider>
  )
}